
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-discrimination-policy",
      function () {
        return require("private-next-pages/non-discrimination-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/non-discrimination-policy"])
      });
    }
  